import React, { Suspense, useState } from 'react';
import { ChatBubbleSmileIcon } from 'tdesign-icons-react';
import { StickyTool } from 'tdesign-react';
import styled from 'styled-components';

import { isAscentstream, sleep } from '@/utils/common';
import Modal from './Modal';

const Draggable = React.lazy(() => import('react-draggable'));

const { StickyItem } = StickyTool;

export default function TrialFeedback() {
  const [visible, setVisible] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const handleClose = () => {
    setVisible(false);
  };

  const handleClick = ({ item }) => {
    if (item.label === '反馈' && !isDragging) {
      setVisible(true);
    }
  };

  return (
    isAscentstream() && (
      <Suspense fallback={null}>
        <Root>
          <Draggable
            axis='both'
            handle='.draggle-feedback'
            bounds={{ top: -300, left: -500, right: 0, bottom: 0 }}
            onDrag={async () => {
              await sleep(100);
              setIsDragging(true);
            }}
            onStop={async () => {
              await sleep(100);
              setIsDragging(false);
            }}
          >
            <div className='draggle-feedback'>
              <StickyTool
                offset={[-40, 60]}
                shape='round'
                style={{ zIndex: 9999 }}
                onClick={handleClick}
              >
                <StickyItem
                  className='animate__animated animate__flipInY animate__infinite'
                  label='反馈'
                  icon={<ChatBubbleSmileIcon />}
                />
              </StickyTool>
            </div>
          </Draggable>
          <Modal visible={visible} handleClose={handleClose} />
        </Root>
      </Suspense>
    )
  );
}

const Root = styled.div`
  z-index: 9999;
  .animate__flipInY {
    animation-name: flipInY;
    animation-duration: 15s;
  }
  @keyframes flipInY {
    from {
      -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
      transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
      -webkit-animation-timing-function: ease-in;
      animation-timing-function: ease-in;
      opacity: 0;
    }

    4% {
      -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
      transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
      -webkit-animation-timing-function: ease-in;
      animation-timing-function: ease-in;
    }

    6% {
      -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
      transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
      opacity: 1;
    }

    8% {
      -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
      transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
    }

    10% {
      -webkit-transform: perspective(400px);
      transform: perspective(400px);
    }
  }
`;
